import createRouter from "./createRouter";
import LayoutContainer from "@/views/Layout/LayoutContainer.vue";

export const routes = [
  {
    path: '/validation',
    redirect: '/validation/client',
    component: LayoutContainer,
    children: [
      {
        path: 'client',
        name: 'ClientCheck',
        component: () => import('@/views/Validation/ClientCheck.vue'),
        meta: {
          title: 'client检查'
        }
      }
    ]
  }
]

export default createRouter(routes)